<template>
  <div>
    <default v-if="theme === '2022_default'"></default>
    <TrDefault v-if="theme === '2023_default'"></TrDefault>
    <NotFound v-if="theme === '404'"></NotFound>
  </div>
</template>

<script>
import Default from '@/components/index/default2022'
import TrDefault from '@/components/index/default2023'
import NotFound from './404'
import { listThemes } from '@/api/goods'

export default {
  name: 'Index',
  components: { Default, TrDefault, NotFound },
  data () {
    return {
      themeList: ['2022_default','2023_default'],
      theme: '2022_default'
    }
  },
  created () {
    if (!this.$route.params || !this.$route.params.type || !this.$route.params.linkId) {
      this.theme = '404'
      return
    }
    this.loadTheme(this.$route.params.type, this.$route.params.linkId)
  },
  methods: {
    loadTheme (type, linkId) {
      listThemes(type, linkId).then(res => {
        if (res.data && this.themeList.findIndex(item => item === res.data.templateNamePc) > 0) {
          this.theme = res.data.templateNamePc
          // this.theme = "2023_default"
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/index.vue